
<script>
export default {
  name: 'RexCheckbox',
  props: {
    name: {
      type: String,
      default: () => null,
      required: true
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    getter: {
      type: String,
      default: () => 'getField'
    },
    setter: {
      type: String,
      default: () => 'setField'
    },
    label: {
      type: String,
      default: () => null
    },
    checkboxLabel: {
      type: String,
      default: () => null
    },
    checkboxBadge: {
      type: String,
      default: () => null
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: () => true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: () => false
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
    hasBackendValidation: {
      type: Boolean,
      default: () => false
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    }
  },
  inject: ['$validator'],
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getter}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setter}`, {
          target: this.target,
          value
        })

        if (this.error !== null && this.hasBackendValidation) {
          const target = this.target.split('.')
          const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          const currentFieldErrorIndex = err.map(x => x.source).indexOf(this.name)

          err.splice(currentFieldErrorIndex, 1)
          this.$store.commit(`${this.storeModule}/${this.setter}`, err)
        }

        this.$emit('change', {
          event: value,
          element: this.$vnode.elm
        })
      }
    },
    error() {
      let error = null

      if (this.hasBackendValidation) {
        const target = this.target.split('.')
        const err = this.$store.getters[`${this.storeModule}/${this.getter}`](`${target[0]}Errors`)
          .find(item => item.source === this.name)

        error = err ? err.detail : null
      }

      return error
    },
  },
}
</script>

<template>
  <b-field
    :label="label"
    custom-class="rex-label"
    :type="{'is-danger': errors.has(name) || error}"
    :message="errors.first(name) || error"
  >
    <b-checkbox
      v-model="value"
      v-validate="validate"
      :name="name"
      :disabled="isDisabled"
      :true-value="trueValue"
      :false-value="falseValue"
      class="rex-checkbox"
    >
      <div class="rex-checkbox__label">
        <span>{{ checkboxLabel }}</span>
        <span
          v-if="checkboxBadge"
          class="rex-checkbox__label-badge"
        >
          {{ checkboxBadge }}
        </span>
      </div>
    </b-checkbox>
  </b-field>
</template>